import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ButtonModule, ToggleModule, TooltipModule} from "@xref/xref-lib";
import {MfaModalComponent} from "./mfa-modal.component";
import { InputsModule } from '@xref/xref-lib';
import {PhoneInputModule} from "../../lib/phone-input/phone-input.module";
import {LoaderModule} from "../loader/loader.module";


@NgModule({
  declarations: [MfaModalComponent],
  imports: [
    CommonModule,
    LoaderModule,
    FormsModule,
    PhoneInputModule,
    ReactiveFormsModule,
    AlertMessageModule,
    TooltipModule,
    ButtonModule,
    ToggleModule,
    InputsModule
  ],
  exports: [MfaModalComponent]
})
export class MfaModalModule {
}
